export default __webpack_public_path__ + "static/ourwork-aae0779b4d359401315ff005d0cc1058.png";